import { sessionCategories, type SessionCategory } from './questionSession';

export function sessionCategoryFromSearch(search: string): SessionCategory {
  const values = new URLSearchParams(search).getAll('category');
  return values.length === 1 && sessionCategories.includes(values[0] as SessionCategory) ? values[0] as SessionCategory : 'all';
}

export function playDestination(authenticated: boolean, category: SessionCategory = 'all'): string {
  const path = authenticated ? '/solo' : '/play';
  return category !== 'all' && sessionCategories.includes(category) ? `${path}?category=${category}` : path;
}
